import { useLayoutEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../auth/AuthProvider";

/** Guards every portal route: the entity comes from the session, never from the URL. */
export function RequireEntityUser() {
  const { me, status } = useAuth();
  const location = useLocation();
  const portal = status === "authenticated" && me?.surface === "portal";

  useLayoutEffect(() => {
    if (!portal) return;
    const previous = document.body.className;
    document.body.className = "surface-portal";
    return () => {
      document.body.className = previous;
    };
  }, [portal]);

  if (status === "loading") {
    return (
      <div className="page-loading" role="status" aria-label="Loading">
        <span className="page-loading-dot" />
      </div>
    );
  }

  if (status === "anonymous" || !me) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/portal/signin?next=${next}`} replace />;
  }

  if (me.surface !== "portal") return <Navigate to="/" replace />;

  return <Outlet />;
}
